export enum NewVpaReceivableStatus {
  Transitioning = 'Transitioning from old to new status',
  Unsubmitted = 'Unsubmitted',
  WaitingForApproval = 'Waiting For Approval',
  Invalid = 'Invalid',
  Approved = 'Approved',
  FullyPaid = 'Paid',
  Cancelled = 'Cancelled'
}
